// Initialize star scroll section
function initStarScroll() {
    // Initialiser tous les paragraphes : envelopper chaque mot dans un span
    ['text1', 'text2', 'text4', 'text5', 'text6'].forEach(paragraphId => {
        const textContainer = document.getElementById(paragraphId);
        if (textContainer && textContainer.textContent && !textContainer.querySelector('.word')) {
            const words = textContainer.textContent.split(' ').map(word => `<span class="word">${word}</span>`);
            textContainer.innerHTML = words.join(' ');
        }
    });

    // Trigger initial state
    handleStarScroll();
}

// Fonction pour gérer l'effet de scroll
function handleStarScroll() {
    const section = document.querySelector('.section-star-scroll');
    if (!section) return;

    const sectionRect = section.getBoundingClientRect();
    const sectionTop = sectionRect.top;
    const windowHeight = window.innerHeight;
    const words = document.querySelectorAll('.word');
    const totalWords = words.length;

    // Point où l'animation se termine : sectionTop atteint 50% de l'écran
    const animationEnd = windowHeight * 0.1;
    // Point de départ : quand la section entre dans la vue (sectionTop = windowHeight)
    const animationStart = windowHeight * 0.7;

    // Calculer la progression (0 à 1) entre animationStart et animationEnd
    let scrollProgress = (animationStart - sectionTop) / (animationStart - animationEnd);
    scrollProgress = Math.max(0, Math.min(1, scrollProgress));

    words.forEach((word, index) => {
        // Calculer l'opacité pour chaque mot en fonction de son index et de la progression du scroll
        const wordProgress = (index + 1) / totalWords;
        if (scrollProgress >= wordProgress) {
            word.classList.add('visible');
            if (word.classList.contains('middle--text')) {
                const maxWidth = word.scrollWidth;
                word.style.width = maxWidth + 'px';
            }
        } else {
            word.classList.remove('visible');
            if (word.classList.contains('middle--text')) {
                word.style.width = '0px';
            }
        }
    });
}

// Écouter l'événement de scroll
window.addEventListener('scroll', handleStarScroll);

// Appeler au chargement pour initialiser l'état
window.addEventListener('load', initStarScroll);

// Listen for variant changes
document.addEventListener('variantChanged', initStarScroll);
